<template>
  <modal-base
    title="Gesundheitsregionplus im Gesundheitsamt des Landkreises Roth"
    ref="modal"
  >
    <p>Informationspflichten bei der Erhebung von Daten nach Art. 13 DSGVO</p>
    <ol>
      <li>
        <p>Bezeichnung der Verarbeitungstätigkeit</p>
        <p>
          Diese Datenschutzhinweise ergehen im Zusammenhang mit der Nutzung des
          online-Vermittlungsportals zur Vermittlung von Hebammen im Landkreis
          Roth
        </p>
      </li>
      <li>
        <p>Verantwortlich für die Datenerhebung</p>
        <p>
          Verantwortlich für die Datenerhebung ist das Landratsamt Roth,
          Weinbergweg 1, 91154 Roth, Tel.: 09171 / 81-0, E-Mail:
          info@landratsamt-roth.de
        </p>
      </li>
      <li>
        <p>Kontaktdaten des Behördlichen Datenschutzbeauftragten</p>
        <p>
          Landratsamt Roth, Behördliche Datenschutzbeauftragte, Weinbergweg 1,
          91154 Roth, Tel.: 09171 / 81-0
        </p>
      </li>
      <li>
        <p>Zweck und Rechtsgrundlage der Verarbeitung</p>
        <p>Zwecke der Verarbeitung:</p>
        <ul>
          <li>
            Ihre Daten werden zweckgebunden für die Vermittlung von Hebammen
            erhoben und gespeichert.
          </li>
          <li>
            Die Daten werden in anonymisierter Form für eine Auswertung
            verwendet, um die Nutzung des Portals zu analysieren.
          </li>
        </ul>
        <p>Rechtsgrundlage der Verarbeitung:</p>
        <ul>
          <li>
            Rechtsgrundlage der Verarbeitung ist Ihre nach Art. 6 Abs. 1 S. 1
            lit. a DSGVO erteilte Einwilligung. (Die Einwilligung wird durch die
            Nutzung / Anklicken bestätigt)
          </li>
        </ul>
      </li>
      <li>
        <p>
          Empfänger oder Kategorien von Empfänger der personenbezogenen Daten
        </p>
        <p>Ihre personenbezogenen Daten werden weitergegeben an:</p>
        <ul>
          <li>
            Hebammen, welche Leistungen im Landkreis Roth anbieten, um eine für
            Sie passende Hebamme vermitteln zu können.
          </li>
        </ul>
      </li>
      <li>
        <p>Dauer der Speicherung der personenbezogenen Daten</p>
        <p>
          Ihre personenbezogenen Daten werden nach Erhebung für die Dauer von 30
          Tagen gespeichert.
        </p>
      </li>
      <li>
        <p>Betroffenenrechte</p>
        <p>
          Nach der Datenschutzgrundverordnung stehen Ihnen folgende Rechte zu:
        </p>
        <ul>
          <li>
            Werden Ihre personenbezogenen Daten verarbeitet, so haben Sie das
            Recht Auskunft über die zu Ihrer Person gespeicherten Daten zu
            erhalten (Art. 15 DSGVO).
          </li>
          <li>
            Sollten unrichtige personenbezogene Daten verarbeitet werden, steht
            Ihnen ein Recht auf Berichtigung zu (Art. 16 DSGVO).
          </li>
          <li>
            Liegen die gesetzlichen Voraussetzungen vor, so können Sie die
            Löschung oder Einschränkung der Verarbeitung verlangen sowie
            Widerspruch gegen die Verarbeitung einlegen (Art. 17, 18 und 21
            DSGVO).
          </li>
          <li>
            Sollten Sie von Ihren oben genannten Rechten Gebrauch machen, prüft
            die öffentliche Stelle, ob die gesetzlichen Voraussetzungen hierfür
            erfüllt sind.
          </li>
          <li>
            Weiterhin besteht ein Beschwerderecht beim Bayerischen
            Landesbeauftragten für den Datenschutz.
          </li>
        </ul>
      </li>
      <li>
        <p>Widerrufsrecht bei Einwilligung</p>
        <p>
          Wenn Sie in die Verarbeitung Ihrer personenbezogenen Daten durch das
          Landratsamt Roth durch eine entsprechende Erklärung eingewilligt
          haben, können Sie die Einwilligung jederzeit für die Zukunft
          widerrufen. Die Rechtmäßigkeit der aufgrund der Einwilligung bis zum
          Widerruf erfolgten Datenverarbeitung wird durch diesen nicht berührt.
        </p>
      </li>
    </ol>
    <p>
      Allgemeine Erläuterungen zum Datenschutz finden Sie auf der Internetseite
      des Landratsamtes Roth
    </p>
  </modal-base>
</template>

<script>
import ModalBase from "./ModalBase";
import { modalBaseMixin } from "../../mixins/modalBase";

export default {
  name: "PrivacyInfoModal",
  components: { ModalBase },
  mixins: [modalBaseMixin]
};
</script>

<style scoped></style>
